(function($){
    'use strict';

    // Add select2 for all select  Remove search in select dropdown

    $('select:not(.country-select):not(.alg_currency_select)').select2(
        {minimumResultsForSearch: Infinity,
            dropdownAutoWidth : false,
            width: '100%'
        }
    );

    // multiSelect for country-select SMS marketing

    if ($(".country-select").length) {

        var select_title = $(".country-select").data('title');
        $('.country-select').multiSelect({
            'noneText': select_title
        });
        // Text to show when no option is selected


        $(window).on("load",function(){
            $(".multi-select-menu").mCustomScrollbar(
                {
                    theme:"dark",
                    autoDraggerLength:false
                }
            );
        });
    }

    if ($('.plus').length || $('.minus').length) {
        $(document).on('click', '.plus', function(e){
            e.preventDefault();
            var input = $(this).parent().find('input');

            var max = input.attr('max') || false;
            var value = input.val();
            value++;
            if( value == max) {
                value = max;
            }
            input.val(value).trigger("change");
        })

        $(document).on('click', '.minus', function(e){
            e.preventDefault();
            var input = $(this).parent().find('input');

            var min = input.attr('min') || false;

            var value = input.val();
            value--;
            if(!min || value < min) {
                value = min;
            }
            input.val(value).trigger("change");

        });
    }

    // fix for select2 hover

    if ($('.single-product').length) {
        $(document).on('mouseenter mouseleave', '.select2-container--open', function(e) {
            if ($('.woocommerce-product-gallery__wrapper').length) {
                if ($('.woocommerce-product-gallery__wrapper').hasClass('active')) {
                    $('.woocommerce-product-gallery__wrapper').removeClass('active');
                } else {
                    $('.woocommerce-product-gallery__wrapper').addClass('active');
                }
            }
        });
    }

    // Acordion
    if ($('.accordion').length) {
        $('.toggle').on('click', function(e) {
            // e.preventDefault();

            let $this = $(this);

            if ($this.next().hasClass('show')) {
                $this.next().removeClass('show');
                $this.next().slideUp(350);
                $this.parent().removeClass('open');
                // $this.parent().toggleClass('open');
            } else {
                $this.parent().parent().find('li .inner').removeClass('show');
                $this.parent().parent().find('li').removeClass('open');
                $this.parent().parent().find('li .inner').slideUp(350);
                $this.next().toggleClass('show');
                $this.next().slideToggle(350);
                $this.parent().toggleClass('open');
                var dest = $( '[data-anchor="services_plans"]' );
                if (dest.length) {
                    scrollAnimate( dest );
                }
            }
        });


    }

    // Acordion
    if ($('.togle-next-block').length) {


        $('.togle-next-block').on('click', function(e) {
            e.preventDefault();
            // $('.togle-next-block').removeClass('show');
            // $(this).addClass('show');

            if ( !$(this).hasClass('show') ) {
                $('.togle-next-block').next().slideUp(350);
                $(this).next().slideDown(350);
                $('.togle-next-block').removeClass('show');
                $(this).addClass('show');
                var dest = $( '[data-anchor="services_plans"]' );
                if (dest.length) {
                    scrollAnimate( dest );
                }
            } else {
                $('.togle-next-block').next().slideUp(350);
                $(this).next().slideUp(350);
                $(this).removeClass('show');
            }
        });

    }




    // Scroll to top
    if ($('.link-up').length) {
        var dest = $( '.wrapper' );

        $(document).on('click', '.link-up', function(e) {
            e.preventDefault();
            scrollAnimate( dest );
        });
    }


    function scrollAnimate( dest ) {
        var headerHeight = $('header').outerHeight();
        if( $('#wpadminbar').length > 0 ) {
            headerHeight = headerHeight + $('#wpadminbar').outerHeight()
        }
        $( 'html,body' ).animate(
            {
                scrollTop: dest.offset().top
            }, {
                duration: 1000,
                step: function (now, fx)
                {
                    var newOffset = dest.offset().top - headerHeight;
                    if (fx.end !== newOffset)
                        fx.end = newOffset;
                }
            }
        );
    }

    location_map_init();

    function location_map_init() {
        if ( $('.location-card').length) {
            $('.location-point, .location-desc').on("mouseenter mouseleave click", function(){
                if (!$(this).parent().hasClass('open')) {
                    $('.location-address').slideUp(350);
                    $('.location-card').removeClass('open');
                    $(this).parent().addClass('open');
                    $(this).parent().find('.location-address').slideDown(350);
                }
            });
        }
    }


    video_player_init();
    // POST commands to YouTube or Vimeo API
    function video_player_init() {

        if ( $('.video-iframe-container').length) {

            $(document).on('click', '.start-video-js', function(e) {

                e.preventDefault();
                var poster = $(this);
                var wrapper = poster.closest('.video-iframe-container');
                videoPlay(wrapper);

                function videoPlay(wrapper) {
                    var iframe = wrapper.find('.video-player');
                    var src = iframe.data('src');
                    wrapper.addClass('video-play');
                    iframe.attr('src',src);
                }
            });
        }

    }


    input_upload_file_init();

    function input_upload_file_init(){

        if ( !$('.uploud-avatar').length) return false;

        var container = $('.uploud-avatar'),
            inputFile = $('#file'),
            img,
            btn;

        var maxSize = inputFile.data('max-size');
        btn = $('#upload');
        img = $('.pp-user-avatar');

        btn.on('click', function(){
            // img.animate({opacity: 0}, 350);
            inputFile.click();
        });

        inputFile.on('change', function(e){
            var i = 0;
            for(i; i < e.originalEvent.srcElement.files.length; i++) {
                var file = e.originalEvent.srcElement.files[i],
                    reader = new FileReader();

                // console.log ('size' + file.size);

                if(file.size>maxSize){
                    alert('File size is more then ' + maxSize + ' bytes');
                    return false;
                } else {
                    reader.onloadend = function(){
                        img.animate({opacity: 0}, 350);
                        setTimeout(function(){
                            img.attr('src', reader.result).animate({opacity: 1}, 700);
                        }, 350);
                    }
                    reader.readAsDataURL(file);
                    img.removeClass('hidden');

                    container.find('.display-file-name').html( file.name /* inputFile.val() */ );

                }

            }

        });
    }

    input_upload_company_logo_init();

    function input_upload_company_logo_init(){

        if ( !$('.upload-company-logo').length) return false;

        var container_c = $('.upload-company-logo'),
            inputFile_c = $('#user_company_logo'),
            img_c,
            btn_c;

        var maxSize = inputFile_c.data('max-size');
        btn_c = $('#upload_user_company_logo');
        img_c = $('.img-company-logo');

        btn_c.on('click', function(){
            // img.animate({opacity: 0}, 350);
            inputFile_c.click();
        });

        inputFile_c.on('change', function(e){
            var i = 0;
            for(i; i < e.originalEvent.srcElement.files.length; i++) {
                var file_c = e.originalEvent.srcElement.files[i],
                    reader_c = new FileReader();

                // console.log ('size' + file.size);

                if(file_c.size>maxSize){
                    alert('File size is more then ' + maxSize + ' bytes');
                    return false;
                } else {
                    reader_c.onloadend = function(){
                        img_c.animate({opacity: 0}, 350);
                        setTimeout(function(){
                            img_c.attr('src', reader_c.result).animate({opacity: 1}, 700);
                        }, 350);
                    }
                    reader_c.readAsDataURL(file_c);
                    img_c.removeClass('hidden');

                    container_c.find('.display-file-name').html( file_c.name /* inputFile.val() */ );

                }

            }

        });
    }

    update_menu_dashboard_init()
    function update_menu_dashboard_init() {

        var url = window.location.href;

        if (url.includes('/my-account/documents')) {
            $('.updated-count-documents').remove();
        }

        if (url.includes('/my-account/sales')) {
            $('.updated-count-sales').remove();
        }

        if (url.includes('/my-account/library')) {
            $('.updated-count-library').remove();
        }

        if (url.includes('/my-account/campaigns')) {
            $('.updated-count-campaigns').remove();
        }

    }

})(jQuery);